import { useMutation } from "@tanstack/react-query";
import { deleteApiUsersUserID } from "Infrastructure/Api/Api";
import { HttpStatusCode } from "Infrastructure/Models/HttpStatusCodes";
import { useSnackbar } from "Infrastructure/Providers/SnackbarProvider/SnackbarProvider";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting, getPath } from "Infrastructure/Utils/UrlUtils";
import { useNavigate } from "react-router-dom";

export function useUserDeleteMutation() {
	const navigate = useNavigate();
	const showSnackbar = useSnackbar();
	const { t } = useResource();

	const mutation = useMutation({
		mutationFn: deleteApiUsersUserID,
		onSuccess: (data) => {
			if (data.status === HttpStatusCode.Ok) {
				showSnackbar("Uživatel odstraněn.", "success");
				navigate(getPath(AppRouting.Users));
			} else {
				showSnackbar(t(Resources.Errors.Error500), "error");
			}
		},
	});

	return mutation;
}
